import { render, staticRenderFns } from "./activeManageIndex.vue?vue&type=template&id=2ccf1708&scoped=true"
import script from "./activeManageIndex.vue?vue&type=script&lang=js"
export * from "./activeManageIndex.vue?vue&type=script&lang=js"
import style0 from "./activeManageIndex.vue?vue&type=style&index=0&id=2ccf1708&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccf1708",
  null
  
)

export default component.exports